import Backbone from 'backbone'
import Stomp from 'webstomp-client'
import $ from 'jquery'
import _ from 'lodash'
import {getBaseUrl} from 'scoreboard/components/scoreboard-url'
import Back from 'back'

let clientPromise = $.Deferred()

// Exponential backoff starting at .5s up to 1 minute, then retry every minute
let attempt = new Back({retries: Number.MAX_VALUE, maxDelay: 1000 * 60})
let wsBaseUrl

function connectWebsocket(resubscribe) {

	let retryConnection = err => {
		// //auto reconnect with backoff attempts to prevent clients from flooding the server with reconnects
		attempt.backoff(fail => {
			if (fail) {
				attempt = new Back({retries: Number.MAX_VALUE})
			}
			console.log('retrying websocket connection')
			connectWebsocket(true)
		})
	}

	var socket = new WebSocket(wsBaseUrl + 'updates')
	var stompClient = Stomp.over(socket, { debug: false })
	stompClient.connect({}, frame => {
		console.log('websocket connected')
		if (clientPromise.state() !== 'pending') {
			// #32405 a promise can't be resolved more than once; if a connection
			// is lost and later re-established we need a new promise.
			clientPromise = $.Deferred()
		}
		clientPromise.resolve(stompClient)
		if (resubscribe) {
			Backbone.trigger('websocket:reconnect', stompClient)
		}
	}, retryConnection)
}

Backbone.on('load', data => {

	const {messageCode} = data

	// This will fail on the server and we'll have an open websocket connection doing nothing
	if (messageCode !== 'login.error.password') {
		var httpBase = getBaseUrl()

		// Constructs an appropriate base URL for websockets based on the HTTP base URL.
		// eg. turns "https://qa.spiderstrategies.com/cms31/" into "wss://qa.spiderstrategies.com/cms31/")
		wsBaseUrl = _.startsWith(httpBase, 'https') ? httpBase.replace('https', 'wss') : httpBase.replace('http', 'ws')
		connectWebsocket()
	}
})

/**
 * It would be ideal to just unsubscribe and resubscribe as the new user.
 *
 * But because simp captures the session attributes at the time the connection
 * is established, SubscriptionSecurityInterceptor is unable to see the changes
 * to session state with respect to impersonation.
 *
 * For this reason we must disconnect and setup a new connection every time
 * the active userId changes in the session.
 */
function reconnectAsCurrentUser() {
	clientPromise.then(stompClient => {
		stompClient.disconnect()
		clientPromise = $.Deferred()
		connectWebsocket(true)
	})
}

/**
 * @returns {Promise} A promise fulfilled with the latest websocket client (if it was lost/reconnected)
 */
function latest() {
	return clientPromise
}
export { latest }
export { reconnectAsCurrentUser }
